// Core: region -> what the Sign In page shows. No React, no assets, no env reads.
export const getSignInAsideContent = (isSA) => ({
	logoStrip: isSA ? 'ksa' : 'uae',
	showNonResidentLink: isSA,
});
